export class ObjectHelper
{
    public hasProperty<TObject extends {}>(object: TObject, property: (object: TObject) => any): boolean
    {
        const propertyExpressionParts = property.toString().split('.');
        const propertyName = propertyExpressionParts[propertyExpressionParts.length - 1];
        const objectProperties = Object.keys(object);
        const hasProperty = objectProperties.includes(propertyName);
        return hasProperty;
    }

    public shallowCopy<T>(source: T): T
    {
        const copyOfPrototypes = Object.create(Object.getPrototypeOf(source));
        const copy = Object.assign(copyOfPrototypes, source);
        return copy;
    }

    public setValueByPath(object: any, path: string, value: any): boolean
    {
        const keys = path.split('/').filter(i => !!i);
        let current = object;

        for (let i = 0; i < keys.length - 1; i++)
        {
            const key = keys[i];
            if (!(key in current))
            {
                return false;
            }
            current = current[key];
        }

        const key = keys[keys.length - 1];
        current[key] = value;
        return true;
    }
}